import { useNavigate } from 'react-router-dom';
import { AuthForm } from '../components/auth/AuthForm';
import { useAuth } from '../context/AuthContext';
import '../styles/auth.css';

export default function AuthPage({ mode = 'login' }) {
  const navigate = useNavigate();
  const { user, loading, logout, authError } = useAuth();
  return <main className="nextxus-auth-page" data-testid="auth-page">
    <div className="auth-page-inner">
      <header className="auth-page-header">
        <img src="/assets/aria-face.jpeg" alt="Aria, the Heart" data-testid="auth-page-portrait" />
        <p data-testid="auth-page-brand">NextXus Federation</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl" data-testid="auth-page-title">Your account</h1>
      </header>
      {loading ? <p role="status" data-testid="auth-page-loading">Checking your session…</p> : user ?
        <section data-testid="auth-page-signed-in" className="auth-form-content">
          <h2 data-testid="auth-page-user-name">Welcome, {user.name}</h2>
          <p data-testid="auth-page-user-email">{user.email}</p>
          <button className="auth-switch" data-testid="auth-page-home" onClick={() => navigate('/')}>Return to the Federation</button>
          <button className="auth-switch" data-testid="auth-page-logout" onClick={logout}>Log out</button>
          {authError && <p role="alert" className="auth-error" data-testid="auth-page-logout-error">{authError}</p>}
        </section> : <AuthForm key={mode} mode={mode} onSuccess={() => navigate('/', { replace: true })} testId="auth-page" />}
    </div>
  </main>;
}